import './ReportDocumentSavingsTileCard.scss';
import clsx from 'clsx';
import React, { memo } from 'react';
import { SavingTileAmount } from 'src/modules/common/components/SavingTileAmount';

type Props = {
  savingTitle: React.ReactNode;
  icon: React.ReactNode;
  amountTitle: React.ReactNode;
  amount: React.ReactNode;
  unit: React.ReactNode;
  children?: React.ReactNode;
  small: boolean;
  last?: boolean;
};

export const ReportDocumentSavingsTileCard = memo(({
  savingTitle,
  icon,
  amountTitle,
  amount,
  unit,
  children,
  small,
  last = false,
}:Props) => (
  <div className={clsx(
    'bp-report-document-savings-tile-card',
    {
      'bp-report-document-savings-tile-card--sm': small,
      last: last,
    },
  )}
  >
    <div className="bp-report-document-savings-tile-card__title">
      {savingTitle}
    </div>

    <div className="bp-report-document-savings-tile-card__details">
      <div className="bp-report-document-savings-tile-card__icon">
        {icon}
      </div>

      <SavingTileAmount
        title={amountTitle}
        amount={amount}
        unit={unit}
      />
    </div>

    {children && (
      <div>
        {children}
      </div>
    )}

  </div>
));
